<p-fileUpload name="myfile[]" mode="basic" chooseIcon="fa fa-upload" [auto]="true" [accept]="Validation.ExcelFileType"
              (onSelect)="onClickUploadExcel($event.files)" #excelUpload class="journal-files" [pTooltip]="tooltip" tooltipPosition="top">
</p-fileUpload>
